export const AtlasLogoNeutral = () => (
  <svg
    width="145"
    height="48"
    viewBox="0 0 145 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.102 42.016C8.118 42.016 0 33.898 0 23.914C0 13.93 8.118 5.81299 18.102 5.81299V8.69499C9.706 8.69499 2.883 15.518 2.883 23.914C2.883 32.31 9.706 39.133 18.102 39.133V42.015V42.016Z"
      fill="url(#paint0_linear_2317_24696)"
    />
    <path
      d="M18.102 42.016V39.134C26.498 39.134 33.321 32.311 33.321 23.915H36.203C36.203 33.899 28.085 42.017 18.101 42.017L18.102 42.016Z"
      fill="url(#paint1_linear_2317_24696)"
    />
    <path
      d="M36.203 23.914H33.321C33.321 15.518 26.498 8.69499 18.102 8.69499V5.81299C28.086 5.81299 36.204 13.931 36.204 23.915L36.203 23.914Z"
      fill="url(#paint2_linear_2317_24696)"
    />
    <path
      d="M25.813 29.4568C23.891 29.0808 22.374 28.3988 19.853 27.2568C19.157 26.9508 18.391 26.6028 17.514 26.2128C16.985 25.9758 16.498 25.7668 16.01 25.5588C12.209 23.8738 10.12 22.9548 7.558 22.9548C5.762 22.9548 4.411 23.4418 3.659 24.3608C3.144 24.9738 2.935 25.7668 3.088 26.5328L0.261 27.0758C-0.0449997 25.4608 0.372 23.8038 1.431 22.5228C2.35 21.4088 4.16 20.0718 7.558 20.0718C10.733 20.0718 13.295 21.2138 17.18 22.9268C17.653 23.1358 18.141 23.3588 18.67 23.5808C19.561 23.9708 20.341 24.3188 21.037 24.6388C23.446 25.7248 24.769 26.3238 26.37 26.6298L25.813 29.4568Z"
      fill="url(#paint3_linear_2317_24696)"
    />
    <path
      d="M28.627 29.7338C27.666 29.7338 26.747 29.6498 25.814 29.4558L26.371 26.6288C27.123 26.7818 27.861 26.8518 28.627 26.8518C30.409 26.8518 31.76 26.4058 32.54 25.5568C33.32 24.7078 33.348 23.6768 33.306 23.1338L36.174 22.8828C36.327 24.6368 35.798 26.2808 34.67 27.5058C33.737 28.5218 31.941 29.7338 28.627 29.7338Z"
      fill="url(#paint4_linear_2317_24696)"
    />
    <path
      d="M18.102 42.0157V39.1337C22.238 39.1337 24.702 34.9147 24.702 27.8547C24.702 20.7947 22.196 14.8767 17.058 9.40473L19.161 7.42773C24.828 13.4567 27.585 20.1407 27.585 27.8547C27.585 36.5857 23.951 42.0157 18.102 42.0157Z"
      fill="url(#paint5_linear_2317_24696)"
    />
    <path
      d="M18.1 42.0159C11.876 42.0159 8.31097 36.9479 8.31097 28.1059C8.31097 17.7879 12.823 12.0229 17.042 7.44189L19.159 9.39089C14.244 14.7379 11.194 19.7229 11.194 28.1049C11.194 37.2249 14.954 39.1329 18.101 39.1329V42.0149L18.1 42.0159Z"
      fill="url(#paint6_linear_2317_24696)"
    />
    <path
      d="M10.386 25.4177C12.247 25.4177 13.756 23.9087 13.756 22.0477C13.756 20.1867 12.247 18.6777 10.386 18.6777C8.52499 18.6777 7.01599 20.1867 7.01599 22.0477C7.01599 23.9087 8.52499 25.4177 10.386 25.4177Z"
      fill="#758195"
    />
    <path
      d="M25.964 31.2249C27.825 31.2249 29.334 29.7159 29.334 27.8549C29.334 25.9939 27.825 24.4849 25.964 24.4849C24.103 24.4849 22.594 25.9939 22.594 27.8549C22.594 29.7159 24.103 31.2249 25.964 31.2249Z"
      fill="#758195"
    />
    <path
      d="M18.099 11.1599C19.96 11.1599 21.469 9.65092 21.469 7.78992C21.469 5.92892 19.96 4.41992 18.099 4.41992C16.238 4.41992 14.729 5.92892 14.729 7.78992C14.729 9.65092 16.238 11.1599 18.099 11.1599Z"
      fill="#758195"
    />
    <path
      d="M52.009 31.9091L49.489 38.7041H44.852L56.743 8.51611H61.979L73.884 38.7041H69.247L66.713 31.8531C63.998 32.4101 61.658 32.6751 59.222 32.6751C56.924 32.6751 54.585 32.3971 52.009 31.8951V31.9091ZM65.474 28.4141L59.361 11.8721L53.248 28.4561C55.504 28.8181 57.384 29.0131 59.222 29.0131C61.157 29.0131 63.135 28.7761 65.474 28.4141Z"
      fill="url(#paint7_linear_2317_24696)"
    />
    <path
      d="M84.562 34.986C85.481 34.986 86.358 34.805 87.041 34.666V38.481C86.345 38.662 85.565 38.843 84.381 38.843C79.466 38.843 77.071 35.947 77.071 31.672V19.405H73.353V15.729H77.071V10.855H80.928V15.729H87.041V19.405H80.928V31.589C80.928 33.608 82.125 34.987 84.562 34.987V34.986Z"
      fill="url(#paint8_linear_2317_24696)"
    />
    <path
      d="M97.566 38.8421C93.792 38.8421 91.411 37.0461 91.411 32.8271V6.12012H95.366V32.3681C95.366 34.4431 96.745 35.1671 98.443 35.1671C98.861 35.1671 99.139 35.1671 99.585 35.1251V38.6621C99.265 38.7591 98.569 38.8431 97.566 38.8431V38.8421Z"
      fill="url(#paint9_linear_2317_24696)"
    />
    <path
      d="M135.886 39.163C132.433 39.163 129.634 38.383 127.893 37.464V33.287C129.87 34.429 133.184 35.543 136.067 35.543C138.95 35.543 140.662 34.304 140.662 32.507C140.662 30.71 139.325 29.75 134.967 28.692C129.871 27.453 127.713 25.475 127.713 21.702C127.713 17.706 130.79 15.269 136.026 15.269C139.02 15.269 141.721 16.007 143.42 16.926V21.02C140.663 19.641 138.407 18.903 135.97 18.903C133.074 18.903 131.514 19.919 131.514 21.702C131.514 23.303 132.614 24.32 136.847 25.336C141.944 26.575 144.52 28.455 144.52 32.465C144.52 36.475 142.041 39.177 135.873 39.177L135.887 39.163H135.886Z"
      fill="url(#paint10_linear_2317_24696)"
    />
    <path
      d="M124.123 35.1671C123.009 35.1671 122.508 34.7071 122.508 33.2321V15.7281H118.553V19.7661C117.174 16.7721 114.598 15.2681 111.243 15.2681C104.81 15.2681 101.593 20.7401 101.593 27.2151C101.593 33.6901 104.726 39.1621 110.936 39.1621C114.849 39.1621 117.132 37.4631 118.622 34.4831C118.97 37.3241 120.752 38.8271 123.287 38.8271C124.095 38.8271 124.652 38.7571 125.041 38.6461V35.1091C124.581 35.1511 124.54 35.1511 124.122 35.1511V35.1651L124.123 35.1671ZM118.553 28.1351C118.553 33.2311 115.378 35.4871 111.841 35.4871C107.747 35.4871 105.547 32.7301 105.547 27.2161C105.547 21.7021 107.845 18.9451 112.3 18.9451C115.656 18.9451 118.552 21.2011 118.552 26.2971V28.1351H118.553Z"
      fill="url(#paint11_linear_2317_24696)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2317_24696"
        x1="10.091"
        y1="42.321"
        x2="8.712"
        y2="6.15699"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5" stopColor="#758195" />
        <stop offset="1" stopColor="#2C3E5D" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2317_24696"
        x1="36.512"
        y1="25.504"
        x2="20.485"
        y2="42.074"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#596A85" />
        <stop offset="1" stopColor="#2C3E5D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2317_24696"
        x1="27.153"
        y1="5.81299"
        x2="27.153"
        y2="23.914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#758195" />
        <stop offset="0.59" stopColor="#758195" />
        <stop offset="1" stopColor="#596A85" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2317_24696"
        x1="0.163"
        y1="24.7638"
        x2="26.369"
        y2="24.7638"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.26" stopColor="#758195" />
        <stop offset="1" stopColor="#2C3E5D" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2317_24696"
        x1="28.709"
        y1="28.9948"
        x2="34.432"
        y2="22.9098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#596A85" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2317_24696"
        x1="22.321"
        y1="42.0157"
        x2="22.321"
        y2="7.42773"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.36" stopColor="#758195" />
        <stop offset="1" stopColor="#2C3E5D" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2317_24696"
        x1="13.735"
        y1="42.0159"
        x2="13.735"
        y2="7.44189"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.06" stopColor="#758195" />
        <stop offset="0.58" stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2317_24696"
        x1="143.548"
        y1="-2.84689"
        x2="43.821"
        y2="30.8781"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#596A85" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2317_24696"
        x1="145.593"
        y1="3.18098"
        x2="45.866"
        y2="36.906"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#596A85" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2317_24696"
        x1="146.275"
        y1="5.21912"
        x2="46.549"
        y2="38.9441"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#596A85" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2317_24696"
        x1="151.92"
        y1="21.874"
        x2="52.193"
        y2="55.6121"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#596A85" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2317_24696"
        x1="149.91"
        y1="15.9341"
        x2="50.184"
        y2="49.6591"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#596A85" />
      </linearGradient>
    </defs>
  </svg>
);
